import React from "react";
import { protectedRouteLoader } from "routes/loaders/protectedRouteLoader";

export const postPresentationRoutes = [
  {
    path: "post-presentation",
    loader: protectedRouteLoader,
    lazy: async () => {
      const mod = await import("views/post-presenetation/post-presentation");
      const PostPresentation = mod.PostPresentation ;
      return { Component: PostPresentation };
    },
  },
  {
    path: "presentation-summary",
    loader: protectedRouteLoader,
    lazy: async () => {
      const mod = await import("views/post-presenetation/view-event-summary");
      const ViewEventSummary = mod.ViewEventSummary;
      return { Component: ViewEventSummary };
    },
  },
  {
    path: "event-summary/:eventId",
    loader: protectedRouteLoader,
    lazy: async () => {
      const mod = await import(
        "views/post-presenetation/post-presentation-preview"
      );
      const PostEventSummaryPreview =
        mod.PostEventSummaryPreview ;
      return { Component: PostEventSummaryPreview };
    },
  },
];
